import { Switch } from "@material-ui/core";
import classes from "../index.module.css";
import { useEffect, useState } from "react";
import RonadIcons from "../../../components/iconComponent";
import { HtmlTooltip } from "../../orderPack/list";
import { useOperatorAssignmentContext } from "../ContextProvider";

export const ORDER_TYPE_HELPS = {
  DIGIKALA:
    "همه ی سفارشاتی که مرکز پردازش آن ها ، دیجی کالا است(عادی و ویژه و درب انبار)",
  SNAP: "همه سفارشاتی که مرکز پردازش آن ها، اسنپ شاپ است",
  POST: "(عادی(تاپین)، عادی(تاپین کتاب)، عادی(پست",
  VIP: "(پیک) ویژه (درب انبار) - ویژه ",
  DELIVER_IN_RONAD: "عادی( درب انبار)",
  CHAPAR: "عادي(چاپار)",
  COURIER: "عادي(پيك)",
};

const Orders = () => {
  const [sortByType, setSortByType] = useState(true);

  const [countdown, setCountdown] = useState(0);

  const {
    getStatisticByOrderType,
    getStatisticByDeadline,
    statistic,
    lastRefresh,
    refreshing,
  } = useOperatorAssignmentContext();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(parseInt((Date.now() - lastRefresh) / 1000));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [lastRefresh]);

  useEffect(() => {
    sortByType ? getStatisticByOrderType() : getStatisticByDeadline();
  }, [sortByType]);

  useEffect(() => {
    const intId = setInterval(() => {
      refresh();
    }, 300000);

    return () => clearInterval(intId);
  }, []);

  const refresh = () => {
    sortByType ? getStatisticByOrderType() : getStatisticByDeadline();
  };

  return (
    <div className={classes.orders}>
      <span className={classes.refresh}>
        {refreshing ? (
          <RonadIcons name="refresh-cw-01" color="primary" />
        ) : (
          <>
            <RonadIcons
              name="check-square-broken"
              color="primary"
              onClick={refresh}
            />
            <div>{countdown} ثانیه قبل</div>
          </>
        )}
      </span>
      <div className={classes.smallCard}>
        <h2>{statistic?.delayedItems?.name && "گذشته"}</h2>
        <div className={classes.rows}>
          {statistic?.delayedItems?.items?.map((item) => (
            <div key={item.itemTypeName} className={classes.row}>
              <HtmlTooltip title={ORDER_TYPE_HELPS[item.itemTypeName]}>
                <span>
                  {item.itemTypeTitle}
                  {/* <RonadIcons name="alert-circle" size="16px"/> */}
                </span>
              </HtmlTooltip>
              <span>
                <span>{item.totalCount}</span>/
                <span className={classes.assignmentCount}>
                  {item.assignmentCount}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.card}>
        <h2>{statistic?.todayItems?.name}</h2>
        <div className={classes.date}>
          {new Date().toLocaleDateString("fa-IR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>
        <div className={classes.secondColor}>
          <div className={classes.rowBetween}>
            <span>نوع ارسال</span>
            <span>
              <Switch
                color="default"
                checked={!sortByType}
                onChange={() => setSortByType((s) => !s)}
                name="switch"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </span>
            <span>آخرین فرصت</span>
          </div>
        </div>
        <div className={classes.rows}>
          {statistic?.todayItems?.items?.map((item) => (
            <div key={item.itemTypeName} className={classes.row}>
              <HtmlTooltip title={ORDER_TYPE_HELPS[item.itemTypeName]}>
                <span>
                  {item.itemTypeTitle}
                  {/* <RonadIcons name="alert-circle" size="16px"/> */}
                </span>
              </HtmlTooltip>
              <span>
                <span>{item.totalCount}</span>/
                <span className={classes.assignmentCount}>
                  {item.assignmentCount}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.smallCard}>
        <h2>{statistic?.futureItems?.name}</h2>
        <div className={classes.rows}>
          {statistic?.futureItems?.items?.map((item) => (
            <div key={item.itemTypeName} className={classes.row}>
              <HtmlTooltip title={ORDER_TYPE_HELPS[item.itemTypeName]}>
                <span>
                  {item.itemTypeTitle}
                  {/* <RonadIcons name="alert-circle" size="16px"/> */}
                </span>
              </HtmlTooltip>
              <span>
                <span>{item.totalCount}</span>/
                <span className={classes.assignmentCount}>
                  {item.assignmentCount}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Orders;
